export const URL_USER_MANUAL = 'https://docs.google.com/document/d/1YH5QBiQLo-sWQ2Hf40UEHV2BtpPPy6DMP-qm8H8n3DI/edit?usp=sharing'